// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cresselia: PokeData = {
  "id": 488,
  "name": "cresselia",
  "height": 15,
  "weight": 856,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "mist",
    "psybeam",
    "aurora-beam",
    "confusion",
    "psychic",
    "double-team",
    "recover",
    "slash",
    "safeguard",
    "moonlight",
    "future-sight",
    "psycho-shift",
    "psycho-cut",
    "lunar-dance",
    "ally-switch",
    "moonblast",
    "lunar-blessing"
  ],
  "moves": [
    "tackle",
    "psychic",
    "moonlight",
    "future-sight",
    "moonblast",
    "psywave",
    "psy-pulse",
    "kinesis",
    "synchronize",
    "reflect",
    "psychic-terrain",
    "psychic-fangs",
    "psy-ball"
  ],
  "evolution_chain": {
    "id": 249,
    "item": null,
    "species": [
      {
        "name": "cresselia",
        "order": 489,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 169,
    "speed": 123,
    "ability_power": 108
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
